import Image from "next/image";
import React from "react";
import { cn } from "@/lib/utils";

export default function StoneLogo({ className }: { className?: string }) {
  return (
    <Image
      src="/static/stone_logo.svg"
      alt="Stone Logo"
      width={200}
      height={100}
      unoptimized
      className={cn(className ?? "w-full max-w-20", "dark:invert")}
    />
  );
}
